import { render, staticRenderFns } from "./JobRowCard.vue?vue&type=template&id=0be23d8e&"
import script from "./JobRowCard.vue?vue&type=script&lang=js&"
export * from "./JobRowCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports